export const banner = () => ({
  image: {
    alt: "Watch Size Guide",
    fallback: `${sl.config.jewlr_asset_url}images/info/watches/resizing/banner-watches-resizing.jpg`,
    srcSet: [
      {
        media: "(max-width: 767px)",
        sizes: "100vw",
        srcSet: `${sl.config.jewlr_asset_url}images/info/watches/resizing/banner-watches-resizing-mobile.jpg 767w,
                   ${sl.config.jewlr_asset_url}images/info/watches/resizing/banner-watches-resizing-mobile-2x.jpg 1534w`,
      },
      {
        media: "(min-width: 1024px)",
        sizes: "100vw",
        srcSet: `
                    ${sl.config.jewlr_asset_url}images/info/watches/resizing/banner-watches-resizing.jpg 1x,
                    ${sl.config.jewlr_asset_url}images/info/watches/resizing/banner-watches-resizing.jpg 2x`,
      },
    ],
    style: { width: "100vw" },
  },
  style: {
    pb: { _: "90%", desktop: "23%", tablet: "24%" },
  },
  textarea: {
    texts: [
      {
        style: {
          fontSize: { _: 25, tablet: 35 },
          fontWeight: 700,
          margin: "auto",
          mr: { _: "60%", tablet: 0 },
          mt: { _: "30%", tablet: 0 },
        },
        text: "Watch Size Guide",
        type: "title",
      },
    ],
  },
})

export const menWatchSize = () => [
  {
    image: {
      alt: "32mm Case",
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/resizing/watch-size-32-2x.jpg`,
      srcSet: [
        {
          media: "(max-width: 767px)",
          sizes: "100vw",
          srcSet: `${sl.config.jewlr_asset_url}images/info/watches/resizing/watch-size-32.jpg 767w,
                   ${sl.config.jewlr_asset_url}images/info/watches/resizing/watch-size-32-2x.jpg 1534w`,
        },
        {
          media: "(min-width: 1024px)",
          sizes: "100vw",
          srcSet: `
          ${sl.config.jewlr_asset_url}images/info/watches/resizing/watch-size-32.jpg 1x,
          ${sl.config.jewlr_asset_url}images/info/watches/resizing/watch-size-32-2x.jpg 2x`,
        },
      ],
      style: { mb: 2, width: { _: "100%", tablet: "90%" } },
    },
    text: "32mm Case",
  },
  {
    image: {
      alt: "36mm Case",
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/resizing/watch-size-36-2x.jpg`,
      srcSet: [
        {
          media: "(max-width: 767px)",
          sizes: "100vw",
          srcSet: `${sl.config.jewlr_asset_url}images/info/watches/resizing/watch-size-36.jpg 767w,
                   ${sl.config.jewlr_asset_url}images/info/watches/resizing/watch-size-36-2x.jpg 1534w`,
        },
        {
          media: "(min-width: 1024px)",
          sizes: "100vw",
          srcSet: `
          ${sl.config.jewlr_asset_url}images/info/watches/resizing/watch-size-36.jpg 1x,
          ${sl.config.jewlr_asset_url}images/info/watches/resizing/watch-size-36-2x.jpg 2x`,
        },
      ],
      style: { mb: 2, width: { _: "100%", tablet: "90%" } },
    },

    text: "36mm Case",
  },
  {
    image: {
      alt: "38mm Case",
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/resizing/watch-size-38-2x.jpg`,
      srcSet: [
        {
          media: "(max-width: 767px)",
          sizes: "100vw",
          srcSet: `${sl.config.jewlr_asset_url}images/info/watches/resizing/watch-size-38.jpg 767w,
                  ${sl.config.jewlr_asset_url}images/info/watches/resizing/watch-size-38-2x.jpg 1534w`,
        },
        {
          media: "(min-width: 1024px)",
          sizes: "100vw",
          srcSet: `
          ${sl.config.jewlr_asset_url}images/info/watches/resizing/watch-size-38.jpg 1x,
          ${sl.config.jewlr_asset_url}images/info/watches/resizing/watch-size-38-2x.jpg 2x`,
        },
      ],
      style: { mb: 2, width: { _: "100%", tablet: "90%" } },
    },

    text: "38mm Case",
  },
  {
    image: {
      alt: "40mm Case",
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/resizing/watch-size-40-2x.jpg`,
      srcSet: [
        {
          media: "(max-width: 767px)",
          sizes: "100vw",
          srcSet: `${sl.config.jewlr_asset_url}images/info/watches/resizing/watch-size-40.jpg 767w, ${sl.config.jewlr_asset_url}images/info/watches/resizing/watch-size-40-2x.jpg 1534w`,
        },
        {
          media: "(min-width: 1024px)",
          sizes: "100vw",
          srcSet: `
          ${sl.config.jewlr_asset_url}images/info/watches/resizing/watch-size-40.jpg 1x,
          ${sl.config.jewlr_asset_url}images/info/watches/resizing/watch-size-40-2x.jpg 2x`,
        },
      ],
      style: { mb: 2, width: { _: "100%", tablet: "90%" } },
    },

    text: "40mm Case",
  },
]

export const womenWatchSize = () => [
  {
    image: {
      alt: "32mm Case",
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/resizing/womens-watch-size-32-2x.jpg`,
      srcSet: [
        {
          media: "(max-width: 767px)",
          sizes: "100vw",
          srcSet: `${sl.config.jewlr_asset_url}images/info/watches/resizing/womens-watch-size-32.jpg 767w,
                   ${sl.config.jewlr_asset_url}images/info/watches/resizing/womens-watch-size-32-2x.jpg 1534w`,
        },
        {
          media: "(min-width: 1024px)",
          sizes: "100vw",
          srcSet: `
          ${sl.config.jewlr_asset_url}images/info/watches/resizing/womens-watch-size-32.jpg 1x,
          ${sl.config.jewlr_asset_url}images/info/watches/resizing/womens-watch-size-32-2x.jpg 2x`,
        },
      ],
      style: { mb: 2, width: { _: "100%", tablet: "90%" } },
    },
    text: "32mm Case",
  },
  {
    image: {
      alt: "36mm Case",
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/resizing/womens-watch-size-36-2x.jpg`,
      srcSet: [
        {
          media: "(max-width: 767px)",
          sizes: "100vw",
          srcSet: `${sl.config.jewlr_asset_url}images/info/watches/resizing/womens-watch-size-36.jpg 767w,
                   ${sl.config.jewlr_asset_url}images/info/watches/resizing/womens-watch-size-36-2x.jpg 1534w`,
        },
        {
          media: "(min-width: 1024px)",
          sizes: "100vw",
          srcSet: `
          ${sl.config.jewlr_asset_url}images/info/watches/resizing/womens-watch-size-36.jpg 1x,
          ${sl.config.jewlr_asset_url}images/info/watches/resizing/womens-watch-size-36-2x.jpg 2x`,
        },
      ],
      style: { mb: 2, width: { _: "100%", tablet: "90%" } },
    },

    text: "36mm Case",
  },
  {
    image: {
      alt: "40mm Case",
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/resizing/womens-watch-size-40-2x.jpg`,
      srcSet: [
        {
          media: "(max-width: 767px)",
          sizes: "100vw",
          srcSet: `${sl.config.jewlr_asset_url}images/info/watches/resizing/womens-watch-size-40.jpg 767w,
                  ${sl.config.jewlr_asset_url}images/info/watches/resizing/womens-watch-size-40-2x.jpg 1534w`,
        },
        {
          media: "(min-width: 1024px)",
          sizes: "100vw",
          srcSet: `
          ${sl.config.jewlr_asset_url}images/info/watches/resizing/womens-watch-size-40.jpg 1x,
          ${sl.config.jewlr_asset_url}images/info/watches/resizing/womens-watch-size-40-2x.jpg 2x`,
        },
      ],
      style: { mb: 2, width: { _: "100%", tablet: "90%" } },
    },

    text: "40mm Case",
  },
]

export const womenStrapStyles = () => [
  {
    image: {
      alt: "Croc Style Leather",
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-croc-leather-2x.jpg`,
      srcSet: [
        {
          media: "(max-width: 767px)",
          sizes: "100vw",
          srcSet: `${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-croc-leather.jpg 767w,
                  ${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-croc-leather-2x.jpg 1534w`,
        },
        {
          media: "(min-width: 1024px)",
          sizes: "100vw",
          srcSet: `
          ${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-croc-leather.jpg 1x,
          ${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-croc-leather-2x.jpg 2x`,
        },
      ],
      style: { mb: 3, width: "120px" },
    },
    text: "Croc Style Leather",
  },
  {
    image: {
      alt: "Genuine Leather",
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-burg-leather-2x.jpg`,
      srcSet: [
        {
          media: "(max-width: 767px)",
          sizes: "100vw",
          srcSet: `${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-burg-leather.jpg 767w,
                  ${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-burg-leather-2x.jpg 1534w`,
        },
        {
          media: "(min-width: 1024px)",
          sizes: "100vw",
          srcSet: `
          ${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-burg-leather.jpg 1x,
          ${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-burg-leather-2x.jpg 2x`,
        },
      ],
      style: { mb: 3, width: "120px" },
    },
    text: "Genuine Leather",
  },
  {
    image: {
      alt: "Steel Mesh",
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-mesh-2x.jpg`,
      srcSet: [
        {
          media: "(max-width: 767px)",
          sizes: "100vw",
          srcSet: `${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-mesh.jpg 767w,
                  ${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-mesh-2x.jpg 1534w`,
        },
        {
          media: "(min-width: 1024px)",
          sizes: "100vw",
          srcSet: `
          ${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-mesh.jpg 1x,
          ${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-mesh-2x.jpg 2x`,
        },
      ],
      style: { mb: 3, width: "120px" },
    },
    text: "Steel Mesh",
  },
]

export const menStrapStyles = () => [
  {
    image: {
      alt: "Leather",
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-leather-2x.jpg`,
      srcSet: [
        {
          media: "(max-width: 767px)",
          sizes: "100vw",
          srcSet: `${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-leather.jpg 767w,
                  ${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-leather-2x.jpg 1534w`,
        },
        {
          media: "(min-width: 1024px)",
          sizes: "100vw",
          srcSet: `
          ${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-leather.jpg 1x,
          ${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-leather-2x.jpg 2x`,
        },
      ],
      style: { mb: 3, width: "120px" },
    },
    text: "Leather",
  },
  {
    image: {
      alt: "Nato",
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-nato-2x.jpg`,
      srcSet: [
        {
          media: "(max-width: 767px)",
          sizes: "100vw",
          srcSet: `${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-nato.jpg 767w,
                  ${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-nato-2x.jpg 1534w`,
        },
        {
          media: "(min-width: 1024px)",
          sizes: "100vw",
          srcSet: `
          ${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-nato.jpg 1x,
          ${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-nato-2x.jpg 2x`,
        },
      ],
      style: { mb: 3, width: "120px" },
    },
    text: "Nato",
  },
  {
    image: {
      alt: "Steel Mesh",
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-mesh-2x.jpg`,
      srcSet: [
        {
          media: "(max-width: 767px)",
          sizes: "100vw",
          srcSet: `${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-mesh.jpg 767w,
                  ${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-mesh-2x.jpg 1534w`,
        },
        {
          media: "(min-width: 1024px)",
          sizes: "100vw",
          srcSet: `
          ${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-mesh.jpg 1x,
          ${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-mesh-2x.jpg 2x`,
        },
      ],
      style: { mb: 3, width: "120px" },
    },
    text: "Steel Mesh",
  },
  {
    image: {
      alt: "Steel Link",
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-steel-2x.jpg`,
      srcSet: [
        {
          media: "(max-width: 767px)",
          sizes: "100vw",
          srcSet: `${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-steel.jpg 767w,
                  ${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-steel-2x.jpg 1534w`,
        },
        {
          media: "(min-width: 1024px)",
          sizes: "100vw",
          srcSet: `
          ${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-steel.jpg 1x,
          ${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-steel-2x.jpg 2x`,
        },
      ],
      style: { mb: 3, width: "120px" },
    },
    text: "Steel Link",
  },
  {
    image: {
      alt: "Silicone",
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-silicone-2x.jpg`,
      srcSet: [
        {
          media: "(max-width: 767px)",
          sizes: "100vw",
          srcSet: `${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-silicone.jpg 767w,
                  ${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-silicone-2x.jpg 1534w`,
        },
        {
          media: "(min-width: 1024px)",
          sizes: "100vw",
          srcSet: `
          ${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-silicone.jpg 1x,
          ${sl.config.jewlr_asset_url}images/info/watches/resizing/strap-silicone-2x.jpg 2x`,
        },
      ],
      style: { mb: 3, width: "120px" },
    },
    text: "Silicone",
  },
]

export const watchCollections = () => [
  {
    image: {
      desktop: `${sl.config.jewlr_asset_url}images/info/watches/landing/mens-watches.png`,
      desktop_2x: `${sl.config.jewlr_asset_url}images/info/watches/landing/mens-watches.png`,
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/landing/mens-watches.png`,
      mobile: `${sl.config.jewlr_asset_url}images/info/watches/landing/mens-watches.png`,
      mobile_2x: `${sl.config.jewlr_asset_url}images/info/watches/landing/mens-watches.png`,
      style: {
        mb: 1,
      },
    },
    links: {
      base_style: "button",
      bg: "primary",
      color: "white",
      display: "inline-block",
      padding: "10px 50px",
      text: "Shop Men's",
      url: "/all-mens-watches",
    },
  },
  {
    image: {
      desktop: `${sl.config.jewlr_asset_url}images/info/watches/landing/womens-watches-combo.png`,
      desktop_2x: `${sl.config.jewlr_asset_url}images/info/watches/landing/womens-watches-combo_2x.png`,
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/landing/womens-watches-combo_2x.png`,
      mobile: `${sl.config.jewlr_asset_url}images/info/watches/landing/womens-watches-combo.png`,
      mobile_2x: `${sl.config.jewlr_asset_url}images/info/watches/landing/womens-watches-combo_2x.png`,
      style: {
        mb: 1,
      },
    },
    links: {
      base_style: "button",
      bg: "primary",
      color: "white",
      display: "inline-block",
      padding: "10px 50px",
      text: "Shop Women's",
      url: "/all-womens-watches",
    },
  },
]
